import { Encrypt, stringsToHex } from './json';

export const formatLoginParams = (username, password) => {
    let time = Date.parse(new Date());
    let usernameTem = Encrypt(username, `PCI${time}`);
    let passwordTem = Encrypt(password, `PCI${time}`);
    let params = {
        'u': stringsToHex(usernameTem),
        'p': stringsToHex(passwordTem),
        'x': stringsToHex(username),
        'time': time,
        'alg': '2'
    };
    return params;
};

export const formatResetPwdParams = (oldPassword, password, userCode) => {
    let time = Date.parse(new Date());
    let oldPasswordTem = Encrypt(oldPassword, `PCI${time}`);
    let passwordTem = Encrypt(password, `PCI${time}`);
    let userCodeTem = Encrypt(userCode, `PCI${time}`);
    let params = {
        UserCode: userCodeTem,
        OldPassword: oldPasswordTem,
        Password: passwordTem,
        Time: time
    };
    return params;
};
